import { useNavigate } from 'react-router-dom';
import { Roles } from 'constants/roles';
import { useRolePermissions } from 'hooks/useRolePermissions';
import { PATH } from 'routes/path';

export const useDeniedAccess = (acccessList: Roles[]) => {
    const hasAcccess = useRolePermissions(acccessList);

    const navigate = useNavigate();

    if (!hasAcccess) {
        navigate(PATH.ROOT);
    }
};
